import { Button } from 'shared/components/ui';
import React, { useState } from 'react';
import { ToastContainer } from '../../../shared/components/Toast';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../core/context/AuthContext';
import { authAPI } from '../../../core/api/api';
import './Login.css';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setToast(null);
    try {
      const response = await authAPI.login(credentials);
      if (response.data && response.data.token) {
        const token = response.data.token;
        const menus = response.data.menus || [];
        let username = 'usuario_sistema';
        let role = 'User';
        let esProcesador = 'False';
        let idMedico = null;
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          username = payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ||
                    payload.username || payload.name || payload.sub || 'usuario_sistema';
          role = payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ||
                payload.role || payload.roles || 'User';
          esProcesador = payload['EsProcesador'] || 'False';
          idMedico = payload['idMedico'] ? parseInt(payload['idMedico']) : null;
        } catch (tokenError) {
          console.warn('Error parsing token:', tokenError);
        }
        const userData = {
          ...response.data.user,
          username, role, rol: role, idMedico,
          procesador: esProcesador === 'True' ? 'S' : 'N',
          menus,
        };
        login(userData, token, { user: credentials.user, password: credentials.password });
        navigate('/');
      } else {
        setToast({ message: 'Credenciales inválidas', type: 'error' });
      }
    } catch {
      setToast({ message: 'Error al iniciar sesión. Verifique sus credenciales.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* Panel izquierdo — branding */}
      <div className="login-brand">
        <div className="login-brand-inner">
          <img src="/images/LogoLogin.png" alt="SUGI Logo" className="login-brand-logo" />
          <img src="https://sugi.com.ar/Img/LogoLoginFondo.png" alt="SUGI" className="login-brand-logo-sugi" />          
          <p className="login-brand-subtitle">Sistema Único de Gestión Integral</p>
          <div className="login-brand-features">
            <div className="login-feature">✓ Gestión de turnos y prácticas</div>
            <div className="login-feature">✓ Administración de obras sociales</div>
            <div className="login-feature">✓ Reportes e informes médicos</div>
          </div>
        </div>
        <div className="login-brand-shapes">
          <div className="shape shape-1" />
          <div className="shape shape-2" />
          <div className="shape shape-3" />
        </div>
      </div>

      {/* Panel derecho — formulario */}
      <div className="login-form-panel">
        <div className="login-form-inner">
          <div className="login-form-header">
            <h2 className="login-form-title">Bienvenido</h2>
            <p className="login-form-desc">Ingresá tus credenciales para continuar</p>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="login-field">
              <label className="login-label">Usuario</label>
              <div className="login-input-wrapper">
                <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
                <input
                  type="text"
                  name="user"
                  value={credentials.user}
                  onChange={handleChange}
                  required
                  placeholder="Ingrese su usuario"
                  className="login-input"
                  autoComplete="username"
                  autoFocus
                />
              </div>
            </div>

            <div className="login-field">
              <label className="login-label">Contraseña</label>
              <div className="login-input-wrapper">
                <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                <input
                  type="password"
                  name="password"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  placeholder="Ingrese su contraseña"
                  className="login-input"
                  autoComplete="current-password"
                />
              </div>
            </div>

            <Button type="submit" className="login-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="login-spinner" />
                  Iniciando sesión...
                </>
              ) : (
                'Iniciar Sesión'
              )}
            </Button>
          </form>

          <p className="login-footer-text">© {new Date().getFullYear()} SUGI — Todos los derechos reservados</p>
        </div>
      </div>

      <ToastContainer toast={toast} onClose={() => setToast(null)} />
    </div>
  );
};

export default Login;
